import { httpClient } from "@/shared/api/httpClient";
import type { SupportApiResponse, SupportSubmissionRequest } from "./supportTypes";

export interface SupportApiClient {
  submit(request: SupportSubmissionRequest): Promise<SupportApiResponse>;
  getCaptchaId(url: string): Promise<string>;
}

export async function submitSupportRequest(
  request: SupportSubmissionRequest,
): Promise<SupportApiResponse> {
  return (await httpClient.post("/api/support/submit", request)) as SupportApiResponse;
}

export async function getSupportCaptchaId(url: string): Promise<string> {
  const response = await fetch(url);
  return response.text();
}

export const supportApi: SupportApiClient = {
  submit: submitSupportRequest,
  getCaptchaId: getSupportCaptchaId,
};
